import React from 'react';
import { AgFinancingPhase4Status, AgFinancing, AgGroup } from '@indigo-ag/schema';
import { LinkButton } from '@indigo-ag/component-module';

import i18next from 'core/i18n';
import {
  NotificationSection,
  NotificationSectionProps
} from 'features/brazil-grower/components/BrazilGrowerFinance/shared/NotificationSection/NotificationSection';
import { UserUtil } from 'shared';

interface FundAssignmentStateProps {
  agFinance?: AgFinancing;
}

export const FundAssignmentState: React.FunctionComponent<FundAssignmentStateProps> = ({ agFinance }) => {
  const getNotificationProps: () => NotificationSectionProps = () => {
    const phase4Info = agFinance?.phase4;
    if (!phase4Info) {
      return {
        title: i18next.t('awaitingContractValidation'),
        status: 'warning'
      };
    }

    switch (phase4Info.status) {
      case AgFinancingPhase4Status.AWAITING_ASSIGNMENT:
        return {
          title: i18next.t('fundAssignment'),
          status: 'warning'
        };
      case AgFinancingPhase4Status.ASSIGNED_TO_FUND:
        return {
          title: i18next.t('fundInformationReceive'),
          status: 'warning',
          updatedAt: phase4Info.sentToFundAt,
          updateBy: UserUtil.getUserFullName(phase4Info.sentToFundBy)
        };
      case AgFinancingPhase4Status.RECEIVED_BY_FUND:
        return {
          title: i18next.t('fundInformationReview'),
          status: 'warning',
          updatedAt: phase4Info.receivedByFundAt,
          updateBy: UserUtil.getUserFullName(phase4Info.receivedByFundBy)
        };
      case AgFinancingPhase4Status.AWAITING_MANAGER_APPROVAL:
        return {
          title: i18next.t('awaitingApproval'),
          status: 'warning',
          updatedAt: phase4Info.sentToManagerAt,
          updateBy: UserUtil.getUserFullName(phase4Info.sentToManagerBy)
        };
      case AgFinancingPhase4Status.SUBMITTED_MINUTA:
        return {
          title: i18next.t('submittedMinuta'),
          status: 'success',
          updatedAt: phase4Info.submittedAt,
          updateBy: UserUtil.getUserFullName(phase4Info.submittedBy)
        };
      case AgFinancingPhase4Status.DENIED:
        return {
          title: i18next.t('managerDenied'),
          status: 'warning',
          updatedAt: phase4Info.deniedAt,
          updateBy: UserUtil.getUserFullName(phase4Info.deniedBy)
        };
      case AgFinancingPhase4Status.ON_HOLD:
        return {
          title: i18next.t('onHold'),
          status: 'warning'
        };

      default:
        return {
          title: '',
          status: 'warning'
        };
    }
  };

  const showSessionGroup = (agGroup: AgGroup) => {
    return (
      <>
        <span className="text-transform-capitalize">{i18next.t('negotiationAddedToCession')}</span>
        <LinkButton to={`/cessions/${agGroup.id}`}>#{agGroup.id}</LinkButton>
      </>
    );
  };

  return (
    <NotificationSection {...getNotificationProps()}>
      {agFinance?.agGroup ? showSessionGroup(agFinance.agGroup) : null}
    </NotificationSection>
  );
};
